import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Pauses, TypeReport2 } from 'src/app/data/model/custom-report';

@Component({
  standalone: false,
  selector: 'app-pauses-dialog',
  templateUrl: './pauses-dialog.component.html',
  styleUrls: ['./pauses-dialog.component.scss']
})
export class PausesDialogComponent implements OnInit {
  tooltipText: string = '';
  public get displayedColumns(): string[] {
    return ['inizio_pausa', 'fine_pausa', 'minuti_pausa']
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TypeReport2
  ) { }

  
  ngOnInit(): void {
  }
  

  showTooltip(text: string) {
    this.tooltipText = text;
  }

  hideTooltip() {
    this.tooltipText = '';
  }
}
export type PausesDialogParams = {
  data: any;
  licenseplate:string;
};
